import React from 'react';

export const ProfileIcon = () => {
    return (
        <img
            src="/img/my-account-icon.png"
            alt="Profile"
            width={24}
            height={24}
            style={{ display: 'block' }}
        />
    );
};

export default ProfileIcon;
